import { Model } from "pinia-orm";
import { Attr, Str, Uid, Bool, BelongsToMany, BelongsTo, HasMany } from 'pinia-orm/decorators';
import Group from "./Group";
import UserGroup from "./UserGroup";

export default class User extends Model {
  static entity = "users";
  currentUser = null;
  @Uid() declare id: string;
  @Str("") declare displayName: string;
  @Str("") declare mail: string;
  @Str("") declare userPrincipalName: string;
  @Str("") declare givenName: string;
  @Str("") declare surname: string;
  @Str("") declare officeLocation: string;
  @Str(null) declare department: string;
  @Str("") declare country: string;
  @Str("") declare jobTitle: string;
  @Str("") declare mobilePhone: string;
  @Attr([]) declare businessPhones: string[];
  @Str("") declare faxNumber: string;
  @Attr([]) declare skills: string[];
  @Str(null) declare graphPhoto: string | null;
  @Str(null) declare hireDate: string | null;
  @Str("") declare employeeId: string;
  @Str("") declare managerId: string;
  @Bool(false) declare accountEnabled: boolean;
  @BelongsTo (() => User, 'managerId') declare manager: User | null;
  @BelongsToMany(() => Group, () => UserGroup, 'user_id', 'group_id') declare memberOf: Group[];
  @HasMany(() => Group, 'ownerId') declare ownerOf: Group[]

}
